import _defineProperty from "/app/vetiver/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import clsx from 'clsx';
import React from 'react';
import { ReactSVG } from 'react-svg';
import { capitalize } from '@material-ui/core/utils';
import { makeStyles } from '@material-ui/core/styles'; // ----------------------------------------------------------------------

var useStyles = makeStyles(function (theme) {
  var createStyle = function createStyle(color) {
    return {
      '& svg path': {
        fill: color
      }
    };
  };

  return {
    root: {
      lineHeight: 0,
      '& svg': {
        height: '100%'
      }
    },
    colorInitial: {},
    colorInherit: createStyle('currentColor'),
    colorAction: createStyle(theme.palette.action.active),
    colorDisabled: createStyle(theme.palette.action.disabled),
    colorPrimary: createStyle(theme.palette.primary.main),
    colorSecondary: createStyle(theme.palette.secondary.main),
    colorInfo: createStyle(theme.palette.info.main),
    colorSuccess: createStyle(theme.palette.success.main),
    colorWarning: createStyle(theme.palette.warning.main),
    colorError: createStyle(theme.palette.error.main),
    colorPaper: createStyle(theme.palette.background.paper)
  };
});
export var MIcon = function MIcon(_a) {
  var src = _a.src,
      _a$color = _a.color,
      color = _a$color === void 0 ? 'inherit' : _a$color,
      _a$size = _a.size,
      size = _a$size === void 0 ? 24 : _a$size,
      className = _a.className,
      other = __rest(_a, ["src", "color", "size", "className"]);

  var classes = useStyles();
  return React.createElement(ReactSVG, Object.assign({
    src: src,
    beforeInjection: function beforeInjection(svg) {
      svg.setAttribute('style', "width: ".concat(size, "px"));
    },
    className: clsx(classes.root, _defineProperty({}, classes["color".concat(capitalize(color))], color), className)
  }, other));
};